/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openFinanceSlideout } from '../../actions/lister-actions';
import { FinanceInstallments } from './FinanceInstallments';
import { buildSlideoutPayload } from '../../utilities/finance-utilities';

const FinanceWithChevron = ({
	NewDayFinanceQuote,
	MemberPrice,
	NowPrice,
	Code,
	ColourId,
	PromotionType,
	PromotionMonths,
	financePromotions,
	State,
	useOldPricePod,
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false,
	},
	isSwitch24Product,
	Switch24Pricing,
	representativeAprRateString,
	purchaseAprRateString,
}) => {
	const dispatch = useDispatch();

	const {
		AnnualMembershipFee,
		DeliveryPricingInPricePod,
		UseUpfrontPricingAmounts,
		UseSwitch24,
	} = useSelector((state) => state.featureSwitches);

	const slideoutPayload = buildSlideoutPayload({
		ColourId,
		Code,
   		NowPrice,
    	MemberPrice,
    	AnnualMembershipFee,
		PromotionType,
		PromotionMonths,
    	FinancePromotions: financePromotions,
    	State,
    	UpfrontPricing,
    	Switch24Pricing,
    	UseUpfrontPricingAmounts,
    	UseSwitch24,
    	representativeAprRateString,
    	purchaseAprRateString,
 	 });

	const openFinanceSlideoutWithPayload = () => {
		dispatch(openFinanceSlideout(slideoutPayload));
	};

	const switchMonthlyPayment =
		Switch24Pricing?.Switch24FinanceQuote?.MonthlyPayment;

	return useOldPricePod ? ( //once delivery pricing and upfront are baked in PricePodV1 etc can all go
			<div
				aria-label="Instalments Finance Promotion"
				className="cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative mt-1"
				tabIndex={0}
				role="link"
				onClick={openFinanceSlideoutWithPayload}
				data-tag-name="member-price-monthly-installments-button"
				data-testid="finance-instalments">
				<FinanceInstallments
					UpfrontPricing={UpfrontPricing}
					UseUpfrontPricingAmounts={UseUpfrontPricingAmounts} 
					DeliveryPricingInPricePod={DeliveryPricingInPricePod} 
					NewDayFinanceQuote={NewDayFinanceQuote}
					isSwitch24Product={isSwitch24Product}
					switchMonthlyPayment={switchMonthlyPayment}
				/>
			</div>
		) : (
			<div
				aria-label="Instalments Finance Promotion"
				className={`${
					DeliveryPricingInPricePod ? 'ml-0' : 'ml-3'
				} cursor-pointer text-link text-left leading-tight font-bold text-body-xs mt-0 z-10 relative ${
					isSwitch24Product ? 'mb-0' : 'mb-3'
				}`}
				tabIndex={0}
				role="link"
				onClick={openFinanceSlideoutWithPayload}
				data-tag-name="non-member-display-monthly-installments-button"
				data-testid="non-member-lister-finance-instalments">
				<FinanceInstallments
					UpfrontPricing={UpfrontPricing}
					UseUpfrontPricingAmounts={UseUpfrontPricingAmounts}
					DeliveryPricingInPricePod={DeliveryPricingInPricePod}
					NewDayFinanceQuote={NewDayFinanceQuote}
					isSwitch24Product={isSwitch24Product}
					switchMonthlyPayment={switchMonthlyPayment}
				/>
			</div>
		)
};

export default FinanceWithChevron;
